(function () {

  CatalogSendEmailCtrl.$inject = ['$scope', '$rootScope', 'catalogResource', 'catalogModel', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('CatalogSendEmailCtrl', CatalogSendEmailCtrl);

  function CatalogSendEmailCtrl($scope, $rootScope, catalogResource, catalogModel, $timeout) {

    // 1. modal-show, 2. modal-shown, 3. modal-hide, 4. modal-hidden
    var modalShowListener = $scope.$parent.$on('modal-show', modalShowHandler);
    var modalHiddenListener = $scope.$parent.$on('modal-hidden', modalHiddenHandler);


    $scope.modal = {
      content: {},
      status: '',
      confirmed: false
    };


    $scope.confirmAction = function() {
      $scope.modal.status = 'saving';
      $scope.modal.confirmed = true;
      catalogResource.updateEmail(catalogModel.catalog.id, function() {
        $scope.dismiss();
      });
    };


    function modalShowHandler(event) {
      stopPropagation(event);

      if(!catalogModel.catalogDirty()) {
        initializeView();
        return;
      }

      $scope.modal.status = 'loading';

      var toSave = catalogModel.cleanCatalogForServer();
      catalogResource.update(toSave, function (res) {
        catalogModel.catalog.amtTrainees = res.amtTrainees;
        catalogModel.save();
        initializeView();
      });
    }


    function modalHiddenHandler(event) {
      stopPropagation(event);

      $scope.modal.content = {};
      $scope.modal.status = '';
      $scope.modal.confirmed = false;
      $rootScope.$broadcast('catalogSendEmailModalClosed');
    }


    function initializeView() {
      // Seems like the emit event doesn't ensure another digest cycle to update the view so do this in a timeout.
      $timeout(function () {
        $scope.modal.content.email = $rootScope.trainerEmail;
        $scope.modal.status = '';
        $scope.modal.content.amtTrainees = catalogModel.catalog.amtTrainees;
      });
    }


    function stopPropagation(event) {
      if(!event || typeof event.stopPropagation != 'function')
        return;

      // specifically test for function
      event.stopPropagation();
    }

    $scope.$on('$destroy', function() {
      // need to remove listeners because they are on the parent
      modalHiddenListener();
      modalShowListener();
    });

  }

})();
